import React, { memo } from "react";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/core/styles";
import palette from "../styles/palette";
import { Text, View } from "../Base";

const useStyles = makeStyles(({ typography }) => ({
  root: {
    margin: "40px 125px",
    borderRadius: 10,
  },
  title: {
    padding: "15px 25px 5px",
    color: palette.typography.black.high,
    fontSize: typography.pxToRem(16),
    fontWeight: 500,
    lineHeight: typography.pxToRem(20),
    letterSpacing: typography.pxToRem(-0.32),
    textTransform: "capitalize",
  },
  divider: {
    backgroundColor: palette.typography.black.neutral,
  },
  content: {
    padding: `${typography.pxToRem(30)} ${typography.pxToRem(
      25
    )} ${typography.pxToRem(40)}`,
  },
}));

const SliderCard = ({ title, children }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={5}>
      <Text className={classes.title} component="h6">
        {title}
      </Text>
      <Divider className={classes.divider} />
      <View className={classes.content}>{children}</View>
    </Paper>
  );
};

export default memo(SliderCard);
